import { ButtonBase, Grid } from '@mui/material';
import { memo, useCallback } from 'react';
import { Draggable, Droppable } from '@hello-pangea/dnd';
import { useShowroom } from 'context';

const Shaxmatka2Row = ({
  blockIndex,
  padezdIndex = 0,
  padezd_id,
  block_id,
  floorNumber = 1,
  maxPlace = 8,
}) => {
  const [{ mode, freePlaceData, homeExpanded }, dispatch] = useShowroom();
  const isEditingPlace = mode == 'PLACE_EDIT';

  const homeList = new Array(maxPlace + 1).fill(null);

  const onClickFreePlace = (place, stage) => {
    dispatch({
      type: 'setFreePlaceData',
      payload: { place, stage, block_id, padezd_id },
    });
    dispatch({ type: 'setHomeExpanded', payload: true });
  };

  const isSelectedPlace = useCallback(
    (place) => {
      if (!freePlaceData || mode != 'PLACE_EDIT' || !homeExpanded) return false;
      return (
        freePlaceData?.place == place &&
        freePlaceData?.stage == floorNumber &&
        freePlaceData?.block_id == block_id &&
        freePlaceData?.padezd_id == padezd_id
      );
    },
    [freePlaceData, floorNumber, block_id, padezd_id, homeExpanded],
  );
  return (
    <Droppable
      droppableId={`droppable-floor-${blockIndex}-${padezdIndex}-${floorNumber}`}
      direction='horizontal'
    >
      {(provided, snapshot) => (
        <Grid
          container
          rowSpacing={0}
          columns={{
            xs: parseInt(maxPlace + 1),
            sm: parseInt(maxPlace + 1),
          }}
          className={'sheet-home-row'}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {padezdIndex == 0 && (
            <Grid item sm={1} xs={1} className='sheet-home-cell !-ml-2.5 !mr-0'>
              <ButtonBase
                className='sheet-home-row-floor h-full w-8 text-sm font-medium !cursor-default'
                disableRipple
              >
                {floorNumber}
              </ButtonBase>
            </Grid>
          )}

          {homeList?.length > 0
            ? homeList.map((item, index) => {
                const keyBase = `block-${blockIndex}-${padezdIndex}-home`;
                return (
                  <Draggable
                    draggableId={`$nan`}
                    index={index}
                    key={`${item?.id}`}
                    isDragDisabled={item?.isFree || mode != 'PLACE_EDIT'}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Grid
                          item
                          sm={1}
                          xs={1}
                          className={`sheet-home-cell floor-${floorNumber} `}
                          id={`${keyBase}-${item}`}
                          key={`${keyBase}-${item}`}
                        >
                          <div
                            className={`block-${blockIndex}-${padezdIndex}-home home-item status-null hover:!bg-base-3 hover:text-white
                              ${isSelectedPlace(index + 1) ? '!border-solid !bg-blue-600 !opacity-100' : ''}
                              ${isEditingPlace ? 'cursor-pointer' : 'cursor-default'}`}
                            onClick={() =>
                              onClickFreePlace(index + 1, floorNumber)
                            }
                          >
                            {mode == 'PLACE_EDIT' && (
                              <i className={`bi bi-plus-lg add-icon `} />
                            )}
                          </div>
                        </Grid>
                      </div>
                    )}
                  </Draggable>
                );
              })
            : [1].map((item) => (
                <Grid
                  item
                  sm={1}
                  xs={1}
                  key={`block-${blockIndex}-home-empty-${item}`}
                  id={`block-${blockIndex}-home-empty-${item}`}
                  className={`sheet-home-cell sheet-home-empty-cell floor-${floorNumber}`}
                >
                  <ButtonBase className='home-item is-empty'>
                    <div className='home-item-data'></div>
                  </ButtonBase>
                </Grid>
              ))}
          {provided.placeholder}
        </Grid>
      )}
    </Droppable>
  );
};

export default memo(Shaxmatka2Row);
